export const MODERATION_ROUTES = {
	ROOT: "/moderation",
} as const;
